import React, { useEffect, useState } from "react";
import { func, string, array, bool, shape } from "prop-types";
import { connect } from "react-redux";
import CertificatesList from "../components/CertificatesList";
import FormModalAddCertificate from "../modals/FormModalAddCertificate";
import DeleteModalConfirmation from "../modals/DeleteModalConfirmation";

function CertificateContainer({
  createCertificate,
  getCertificates,
  deleteCertificate,
  certificates = [],
  loading = false,
  error = null,
  enterprise,
}) {
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [uuidToDelete, setUuidToDelete] = useState(null);

  useEffect(() => {
    getCertificates();
  }, [getCertificates]);

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }

  return (
    <div className="certificate-section">
      <CertificatesList
        certificates={certificates}
        loading={loading}
        enterprise={enterprise}
        onAdd={() => setAddModalOpen(true)}
        onDelete={setUuidToDelete}
      />
      <FormModalAddCertificate
        isOpen={isAddModalOpen}
        onClose={() => setAddModalOpen(false)}
        createCertificate={createCertificate}
        errors={enterprise?.errors}
        isLoading={enterprise?.saving}
      />
      <DeleteModalConfirmation
        isOpen={uuidToDelete !== null}
        onClose={() => setUuidToDelete(null)}
        uuidToDelete={uuidToDelete}
        deleteCertificate={deleteCertificate}
      />
    </div>
  );
}

CertificateContainer.propTypes = {
  createCertificate: func.isRequired,
  getCertificates: func.isRequired,
  deleteCertificate: func.isRequired,
  certificates: array,
  loading: bool,
  error: string,
  enterprise: shape({
    certificateOfProfessionalCompetence: shape({
      number: string,
      startDate: string,
      endDate: string,
    }),
  }),
};

const mapStateToProps = (state) => ({
  certificates: state.enterprise.certificates || [],
  loading: state.enterprise.certificatesLoading || false,
  error: state.enterprise.certificatesError || null,
});

export default connect(mapStateToProps)(CertificateContainer);
